export default __webpack_public_path__ + "static/menu-bg-fe4e946fea4f052d9e4d5f56b4440b4f.png";